// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"42972c21","498":"5e9a6c19","703":"38388e4e"}[chunkId] + ".chunk.js";
};